import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { monoFont } from '../../theme';

const deltaToneColors = {
	up: { fg: 'success.main', bg: 'success.light' },
	down: { fg: 'error.main', bg: 'error.light' },
	flat: { fg: 'text.secondary', bg: 'action.hover' }
};

/**
 * Tarjeta de KPI del panel principal.
 *
 * Diseño tomado del dashboard de la rama Inver-Credit_Kevin: chip de icono de
 * 36px, valor grande y etiqueta debajo. Deliberadamente sobria.
 *
 * `iconBg`/`iconColor` esperan tokens de la paleta ('error.light',
 * 'error.main'), no hex sueltos: con ocho tarjetas en pantalla, restringir los
 * acentos a los colores semanticos del tema es lo que evita que la grilla
 * parezca un semaforo.
 */
const KpiCard = ({
	icon,
	iconBg,
	iconColor,
	value,
	label,
	sub,
	delta,
	deltaTone = 'flat',
	onClick,
	sx
}) => {
	const toneSx = deltaToneColors[deltaTone] || deltaToneColors.flat;

	return (
		<Paper
			onClick={onClick}
			sx={{
				padding: '17px 18px',
				height: '100%',
				cursor: onClick ? 'pointer' : 'default',
				transition: 'border-color .18s ease',
				'&:hover': onClick ? { borderColor: 'text.disabled' } : undefined,
				...sx
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					marginBottom: '12px'
				}}
			>
				<Box
					sx={{
						width: 36,
						height: 36,
						borderRadius: '10px',
						backgroundColor: iconBg,
						color: iconColor,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: 20,
						flexShrink: 0
					}}
				>
					{icon}
				</Box>
				{delta ? (
					<Box
						component="span"
						sx={{
							fontSize: 11.5,
							fontWeight: 600,
							color: toneSx.fg,
							backgroundColor: toneSx.bg,
							padding: '2px 8px',
							borderRadius: '20px'
						}}
					>
						{delta}
					</Box>
				) : null}
			</Box>

			<Typography
				sx={{
					fontFamily: monoFont,
					fontSize: 25,
					fontWeight: 600,
					color: 'text.primary',
					letterSpacing: '-.5px',
					lineHeight: 1,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis'
				}}
				title={typeof value === 'string' ? value : undefined}
			>
				{value}
			</Typography>

			<Typography
				sx={{ fontSize: 12.5, color: 'text.secondary', marginTop: '6px', fontWeight: 500 }}
			>
				{label}
			</Typography>

			{sub ? (
				<Typography sx={{ fontSize: 11.5, color: 'text.disabled', marginTop: '2px' }}>
					{sub}
				</Typography>
			) : null}
		</Paper>
	);
};

export default KpiCard;
